module.exports = __webpack_public_path__ + "img/video_interativo_cameras.6c8e1e79.jpg";